import { createSelector } from 'reselect';

import constants from './constants';

const selectCustomerConfigurationsState = (state) => state[constants.NAME];
const selectCustomerConfiguration = createSelector(
  [selectCustomerConfigurationsState],
  (customerConfigurations) => customerConfigurations.customerConfiguration
);
const selectCustomerConfigurationSimple = createSelector(
  [selectCustomerConfigurationsState],
  (customerConfigurations) => customerConfigurations.customerConfigurationSimple
);
const selectLocalLogoUrl = createSelector(
  [selectCustomerConfigurationsState],
  (customerConfigurations) => customerConfigurations.localLogoUrl
);
const selectDarkLogoUrl = createSelector(
  [selectCustomerConfigurationsState],
  (customerConfigurations) => customerConfigurations.darkLogoUrl
);

export default {
  selectCustomerConfiguration,
  selectCustomerConfigurationSimple,
  selectLocalLogoUrl,
  selectDarkLogoUrl
};
